angular.module('elogbooksServices').service('patrolInstanceModal', ['$uibModal', '$filter', function ($uibModal, $filter) {
    return {
        open: function (instanceResponse, config) {
            return $uibModal.open({
                templateUrl: '/modules/common/modals/patrol-instance/patrol-instance-modal.html',
                controller: 'PatrolInstanceModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    config: function () {
                        var defaultConfig = {
                            titleMessage: 'ARE_YOU_SURE_HEADER',
                            bodyMessage: 'ARE_YOU_SURE',
                            primaryText: 'YES',
                            primaryClass: 'btn-danger',
                            secondaryText: 'NO',
                            secondaryClass: 'btn-default'
                        };

                        return angular.extend({}, defaultConfig, config);
                    },
                    instanceResponse: function() {

                        return instanceResponse;
                    }
                }
            });
        }
    };
}]);
